import { apiClient } from '@/api/api'
import type { SurveyResults } from '@/types/sizes'

/**
 * `GET /survey/results` — sizes matched from the saved measurements. The server reads
 * them by user; the config id the Sizes page passes is not needed (it defaults).
 */
export async function fetchSizesQuizResults(): Promise<SurveyResults> {
  const response = await apiClient.get<{ results: SurveyResults }>('/survey/results', {
    params: { brand: 'all', system: 'metric' },
  })
  return response.data.results
}
